import { Spacers } from "types/generic/types";

export const getSpacersClassNames = ({
  marginBottom,
  marginTop,
  paddingBottom,
  paddingTop,
}: Spacers) => ({
  [`mb--${marginBottom}`]: marginBottom && marginBottom !== "none",
  [`mt--${marginTop}`]: marginTop && marginTop !== "none",
  [`pb--${paddingBottom}`]: paddingBottom && paddingBottom !== "none",
  [`pt--${paddingTop}`]: paddingTop && paddingTop !== "none",
});
